import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import { IoIosWarning } from 'react-icons/io'
import { VscError } from 'react-icons/vsc'
import Palette from '../Palette'
import { useParams, useHistory } from 'react-router-dom'
import MemberCerification from '../models/MemberCertification'
import moment from 'moment'
import usePreventScreenshots from '../components/DisableScreenshot'

function QRCertificatePage() {
    const { token } = useParams()
    const history = useHistory()
    const [certData, setCertData] = useState(null)
    const [isInvalid, setIsInvalid] = useState(false)
    const [isExpired, setIsExpired] = useState(false)
    const [loading, setLoading] = useState(true)
    const isWarning = isInvalid || isExpired

   
    usePreventScreenshots(!isWarning && certData)

    const fetchCertificateDetail = async () => {
        try {
            setLoading(true)
            const response = await MemberCerification.getByToken(token)

            if (response.length === 0) {
                setIsInvalid(true)
            } else {
                const certificate = response[0]
                setCertData(certificate)

                if (moment() > moment(certificate.valid_until)) {
                    setIsExpired(true)
                }
            }
        } catch (error) {
            console.error('Failed to fetch certificate:', error)
            setIsInvalid(true)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchCertificateDetail()
    }, [token])

    const handleViewProfile = () => {
        if (certData && certData.member_id) {
            history.push(`/result/${certData.member_id}`)
        } else {
            
            history.push('/member/akun')
        }
    }

   
    useEffect(() => {
        if (isWarning) return

        const handleContextMenu = (e) => e.preventDefault()
        const handleKeyDown = (e) => {
            if (
                e.key === 'F12' ||
                (e.ctrlKey && e.shiftKey && e.key === 'I') ||
                (e.ctrlKey && e.shiftKey && e.key === 'J') ||
                (e.ctrlKey && e.key === 'U')
            ) {
                e.preventDefault()
            }
        }

        document.addEventListener('contextmenu', handleContextMenu)
        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu)
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [isWarning])

    if (loading) {
        return (
            <Container className="py-4 text-center">
                <div className="spinner-border text-primary" role="status" />
            </Container>
        )
    }
    

    return (
        <Container
            className="py-4"
            onContextMenu={(e) => !isWarning && e.preventDefault()}
            style={{ userSelect: isWarning ? 'auto' : 'none' }}
        >
            <Row>
                <Col md={{ span: 10, offset: 1 }} xs={12}>
                    {/* Valid Certificate Display with JPG Image from Backend */}
                    {!isWarning && certData && certData.path && (
                        <div style={{ position: 'relative' }}>
                            <img
                                src={certData.path}
                                alt="Sertifikat"
                                className="img-fluid mb-4 w-100"
                                style={{
                                    userSelect: 'none',
                                    pointerEvents: 'none',
                                    WebkitUserSelect: 'none',
                                    MozUserSelect: 'none',
                                    msUserSelect: 'none',
                                    position: 'relative',
                                    zIndex: 1,
                                    maxHeight: '800px',
                                    objectFit: 'contain',
                                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                    borderRadius: '8px'
                                }}
                                onContextMenu={(e) => e.preventDefault()}
                                onDragStart={(e) => e.preventDefault()}
                                draggable={false}
                            />
                            
                            {/* Protection Overlays */}
                            <div
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    zIndex: 2,
                                    background: 'rgba(0,0,0,0.01)',
                                    pointerEvents: 'none',
                                }}
                            />
                           <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%) rotate(-45deg)',
                                zIndex: 3,
                                color: 'rgba(0,0,0,0.1)',
                                fontSize: window.innerWidth < 768 ? '1.2rem' : '3rem', // lebih kecil di HP
                                fontWeight: 'bold',
                                whiteSpace: 'nowrap',
                                pointerEvents: 'none',
                                userSelect: 'none',
                            }}
                        >
                            HIMPUNAN PENERJEMAH INDONESIA
                        </div>

                        </div>
                    )}

                    {/* Invalid Certificate Display */}
                    {isInvalid && (
                        <div className="text-center p-4 rounded shadow-sm bg-white">
                            <div className="text-danger mb-3">
                                <div
                                    style={{
                                        width: 120,
                                        height: 120,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0 auto',
                                    }}
                                >
                                    <VscError size={100} color="#ff0000" />
                                </div>
                            </div>
                            <h5 className="fw-bold text-dark mb-2">
                            Sertifikat Tidak Valid<br />
                            <span className="fw-bold text-dark mb-2" style={{ fontStyle: "italic" }}>
                                This Certificate is invalid
                            </span>
                            </h5>

                            <p className="text-muted small mb-0">
                            QR Code tidak cocok dengan sertifikat yang terdaftar resmi di sistem HPI<br />
                            <span className="text-muted" style={{ fontStyle: "italic" }}>
                                The QR Code has no matches on the HPI official directory of certificates
                            </span>
                            </p>
                        </div>
                    )}

                    {/* Expired Certificate Display */}
                    {!isInvalid && isExpired && (
                        <div className="text-center p-4 rounded shadow-sm bg-white">
                            <div className="text-warning mb-3">
                                <div
                                    style={{
                                        width: 120,
                                        height: 120,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0 auto',
                                    }}
                                >
                                    <IoIosWarning size={100} color="#FFA500" />
                                </div>
                            </div>
                            <h5 className="fw-bold text-dark mb-2">
                                Sertifikat Kedaluwarsa<br />
                                <span style={{ fontStyle: 'italic' }} className="text-dark">
                                    This Certificate Has Expired
                                </span>
                            </h5>
                            <p className="text-muted small mb-3">
                                Masa berlaku sertifikat berakhir{' '}
                                <span className="fw-bold text-primary">
                                    {moment(certData.valid_until).format('DD-MM-YYYY')}
                                </span>
                                <br />
                                <span className="text-muted" style={{ fontStyle: "italic" }}>
                                The validity period of this certificate has ended on{" "}
                                <span className="fw-bold text-primary" style={{ fontStyle: "normal" }}>
                                    {moment(certData.valid_until).format("DD-MM-YYYY")}
                                </span>
                                </span>
                            </p>
                            <Button
                                variant="primary"
                                style={{
                                    backgroundColor: Palette.PRIMARY,
                                    borderColor: Palette.PRIMARY,
                                    borderRadius: '20px',
                                    padding: '10px 30px',
                                    fontWeight: 'bold',
                                    marginTop: '1rem'
                                }}
                                onClick={handleViewProfile}
                            >
                                Lihat Profil
                            </Button>
                        </div>
                    )}

                   {/* Certificate Metadata */}
                    {!isWarning && certData && (
                    <div className="bg-light rounded p-4 mb-4 shadow-sm">
                        <Row className="mb-3">
                        <Col xs={6} className="text-muted">
                            Jenis Sertifikat /{" "}
                            <span style={{ fontStyle: "italic" }}>Certificate Type</span>
                        </Col>
                        <Col
                            xs={6}
                            className="fw-bold text-end"
                            style={{ color: Palette.PRIMARY }}
                        >
                            {certData.name}
                        </Col>
                        </Row>

                        <Row className="mb-3">
                        <Col xs={6} className="text-muted">
                            Nomor Sertifikat /{" "}
                            <span style={{ fontStyle: "italic" }}>Certificate Number</span>
                        </Col>
                        <Col
                            xs={6}
                            className="fw-bold text-end"
                            style={{ color: Palette.PRIMARY }}
                        >
                            {certData.certification_number}
                        </Col>
                        </Row>

                        <Row className="mb-3">
                        <Col xs={6} className="text-muted">
                            Tanggal Diterbitkan /{" "}
                            <span style={{ fontStyle: "italic" }}>Valid From</span>
                        </Col>
                        <Col
                            xs={6}
                            className="fw-bold text-end"
                            style={{ color: Palette.PRIMARY }}
                        >
                            {moment(certData.valid_from).format("DD-MM-YYYY")}
                        </Col>
                        </Row>

                        <Row className="mb-3">
                        <Col xs={6} className="text-muted">
                            Masa Berlaku /{" "}
                            <span style={{ fontStyle: "italic" }}>Valid Until</span>
                        </Col>
                        <Col
                            xs={6}
                            className="fw-bold text-end"
                            style={{ color: Palette.PRIMARY }}
                        >
                            {moment(certData.valid_until).format("DD-MM-YYYY")}
                        </Col>
                        </Row>

                        <hr />

                        <p className="text-secondary mb-2">
                        Sertifikat ini telah ditandatangani secara resmi oleh: <br />
                        <span className="text-muted" style={{ fontStyle: "italic" }}>
                            This Certificate has been officially signed by:
                        </span>
                        </p>

                        <Row className="align-items-center mb-2">
                        <Col xs={12} md={8}>
                            <div className="fw-bold" style={{ color: Palette.PRIMARY }}>
                            Dr. Indra Listyo
                            </div>
                            <div className="text-muted">
                            Ketua Umum HPI <br />
                            <span className="text-muted" style={{ fontStyle: "italic" }}>
                                President of HPI
                            </span>
                            </div>
                        </Col>
                        <Col
                            xs={12}
                            md={4}
                            className="text-md-end text-muted mt-2 mt-md-0"
                        >
                            {moment(certData.valid_from).format("DD MMMM YYYY, HH:mm:ss")}
                        </Col>
                        </Row>

                        <Row className="align-items-center mb-2">
                        <Col xs={12} md={8}>
                            <div className="fw-bold" style={{ color: Palette.PRIMARY }}>
                            Dr. Sugeng Hariyanto
                            </div>
                            <div className="text-muted">
                            Ketua Komite Kompetensi dan Sertifikasi HPI <br />
                            <span className="text-muted" style={{ fontStyle: "italic" }}>
                                Chair of HPI Competency and Certification Committee
                            </span>
                            </div>
                        </Col>
                        <Col
                            xs={12}
                            md={4}
                            className="text-md-end text-muted mt-2 mt-md-0"
                        >
                            {moment(certData.valid_from).format("DD MMMM YYYY, HH:mm:ss")}
                        </Col>
                        </Row>

                        <p className="text-start text-secondary mt-4">
                        dan diakui oleh{" "}
                        <span className="fw-bold" style={{ color: Palette.PRIMARY }}>
                            Himpunan Penerjemah Indonesia
                        </span>
                        <br />
                        <span className="text-muted" style={{ fontStyle: "italic" }}>
                            and is verified by{" "}
                            <span className="fw-bold" style={{ color: Palette.PRIMARY }}>
                            the Association of Indonesian Translators
                            </span>
                        </span>
                        </p>
                    </div>
                    )}

                    {!isWarning && certData && (
                        <div className="text-center">
                            <Button
                                variant="primary"
                                style={{
                                    backgroundColor: Palette.PRIMARY,
                                    borderColor: Palette.PRIMARY,
                                    borderRadius: '20px',
                                    padding: '10px 30px',
                                    fontWeight: 'bold',
                                }}
                                onClick={handleViewProfile}
                            >
                                Lihat Profil
                            </Button>
                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    )
}

export default QRCertificatePage